export default __webpack_public_path__ + "static/media/Action_Follow.ba32ee4c.svg";